// import { useMeta } from 'quasar';
import { log } from '@/lib/Debug';
import { useHead } from "@vueuse/head";

// eslint-disable-next-line
let beanfunWebTraceSDK: BGOTrackingInstance;
let sender: BGOTrackingSender;
if (typeof window !== "undefined") {
  // 在客户端环境下执行的代码
  // 访问 window 对象以及相关逻辑
  beanfunWebTraceSDK = window.beanfunWebTraceSDK;
} else {
  // 在服务器端环境下执行的代码
  // 提供服务器端环境的替代逻辑
}
/**
 * 載入 BGO SDK
 */
export const loadSdk = async () => {
  log('load BGO Tracking SDK', import.meta.env.BGO_TRACKING_SDK);
  // useMeta({
  //   script: {
  //     beanfunTracking: {
  //       src: import.meta.env.BGO_TRACKING_SDK,
  //       defer: '',
  //     },
  //   },
  // });
  useHead({
    script: [
      {
        src: import.meta.env.VITE_BGO_TRACKING_SDK,
        defer: '',
        onload: (e) => {
          console.log(e);
        },
      },
    ],
  })
  await checkSdkIsLoaded();

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  beanfunWebTraceSDK = window.beanfunWebTraceSDK;
};

/**
 * 等待並確認 SDK 載入
 */
export const checkSdkIsLoaded = () => {
  return new Promise((resolve) => {
    const timer = setInterval(() => {
      if (window.beanfunWebTraceSDK) {
        log('BGO Tracking SDK: loaded!');
        clearInterval(timer);
        resolve(null);
      }
      log('BGO Tracking SDK: loading...');
    }, 10);
  });
};

/**
 * 初始化 BGO Tracking
 */
export const init = (
  BUID: string,
  property: string,
  sourceProperty: string,
) => {
  const info = {
    BUID,
    property,
    sourceProperty,
  };
  const name = 'beanfunWebTraceSDK.init';
  log(`${name}(${JSON.stringify(info)})`);
  // eslint-disable-next-line
  sender = beanfunWebTraceSDK.init(info);
  log(`${name} sender:`, sender);
};

/** 使用者登入登出狀態更新 */
export const setLoginStatus = () => {
  const info = {
    isLoggedIn: true,
  };
  const name = 'beanfunWebTraceSDK.setLoginStatus';
  log(`${name}(${JSON.stringify(info)})`);
  // eslint-disable-next-line
  beanfunWebTraceSDK.status.setLoginStatus(info);
};

/** 使用beanfun H5網頁，網路資訊變更 */
export const setBfH5network = (network: string) => {
  const info = {
    network,
  };
  const name = 'beanfunWebTraceSDK.setBfH5network';
  log(`${name}(${JSON.stringify(info)})`);
  // eslint-disable-next-line
  beanfunWebTraceSDK.status.setBfH5network(info);
};

/** 使用beanfun H5網頁，裝置資訊 */
export const setBfH5DeviceInfo = (
  deviceId: string,
  deviceModel: string,
  carrier: string,
  osName: string,
  osVersion: string,
) => {
  const info = {
    deviceId,
    deviceModel,
    carrier,
    osName,
    osVersion,
  };
  const name = 'beanfunWebTraceSDK.setBfH5DeviceInfo';
  log(`${name}(${JSON.stringify(info)})`);
  // eslint-disable-next-line
  beanfunWebTraceSDK.status.setBfH5DeviceInfo(info);
};

/** 使用beanfun H5網頁，APP版本變 */
export const changeBfH5APPVersion = (appVersion: string, appBuild: string) => {
  const info = {
    appVersion,
    appBuild,
  };
  const name = 'beanfunWebTraceSDK.changeBfH5APPVersion';
  log(`${name}(${JSON.stringify(info)})`);
  // eslint-disable-next-line
  beanfunWebTraceSDK.status.changeBfH5APPVersion(info);
};

/** 網頁網址變更 */
export const changePageUrl = (pageUri: string) => {
  if (!beanfunWebTraceSDK) {
    return;
  }
  const info = {
    pageUri,
  };
  const name = 'beanfunWebTraceSDK.changeBfH5APPVersion';
  log(`${name}(${JSON.stringify(info)})`);
  // eslint-disable-next-line
  beanfunWebTraceSDK.status.changePageUrl(info);
};

/** 建立事件 */
export const createEvent = (
  eventType: string,
  eventData: BGOTrackingEvent,
): BGOTrackingEvent => {
  log('Tracking Event(info):', `[${eventType}]`, eventData);
  // eslint-disable-next-line
  return new beanfunWebTraceSDK.events[eventType](eventData);
};

/** 發送事件 */
export const passEvent = (event: BGOTrackingEvent | BGOTrackingEvent[]) => {
  if (!sender) {
    return;
  }

  // const name = 'sender.passEvent';
  // log(`${name}((${JSON.stringify(event)})`);
  sender.passEvent(event);
};

export default {
  loadSdk,
  checkSdkIsLoaded,
  init,
  setLoginStatus,
  setBfH5network,
  setBfH5DeviceInfo,
  changeBfH5APPVersion,
  changePageUrl,
  createEvent,
  passEvent,
};
